import { Box, useTheme } from '@mui/material';
import { H5, Small } from 'components/Typography';

const MyPostItem = ({ item, isMobile, onClick, onDelete, ...props }) => {
  const theme = useTheme();

  const handleClick = () => {
    if (onClick) {
      onClick(item);
    }
  };

  const handleDelete = e => {
    e.stopPropagation();
    if (onDelete) {
      onDelete(item);
    }
  };

  // Format time display (e.g., "3일 전", "1주 전")
  const formatTime = timeString => {
    return timeString || '3일 전';
  };

  // Get pill color - support both hex colors and theme color names
  const getPillColor = () => {
    if (!item.pillColor) {
      return theme.palette.primary.mainBlue; // default blue
    }

    // If it's a hex color, use it directly
    if (item.pillColor.startsWith('#')) {
      return item.pillColor;
    }

    // If it's a theme color name, try to get it from theme
    const colorPath = item.pillColor.split('.');
    let color = theme.palette;
    for (const path of colorPath) {
      color = color[path];
      if (!color) break;
    }

    return color || item.pillColor || theme.palette.primary.mainBlue;
  };

  // Get pill text color - support both hex colors and theme color names
  const getPillTextColor = () => {
    if (!item.pillTextColor) {
      return theme.palette.primary.white; // default white
    }

    // If it's a hex color, use it directly
    if (item.pillTextColor.startsWith('#')) {
      return item.pillTextColor;
    }

    // If it's a theme color name, try to get it from theme
    const colorPath = item.pillTextColor.split('.');
    let color = theme.palette;
    for (const path of colorPath) {
      color = color[path];
      if (!color) break;
    }

    return color || item.pillTextColor || theme.palette.primary.white;
  };

  return (
    <Box
      onClick={handleClick}
      sx={{
        cursor: 'pointer',
        transition: 'all 0.2s ease-in-out',
        marginBottom: isMobile ? '12px' : '16px',
        '&:hover': isMobile
          ? {}
          : {
              transform: 'translateY(-1px)',
            },
      }}
      {...props}
    >
      {/* Content Text - Truncated to one line */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: '8px',
        }}
      >
        <H5
          sx={{
            fontWeight: 'bold',
            lineHeight: 1.3,
            fontSize: isMobile ? '15px' : '15px',
            color: theme.palette.text.primary,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            minWidth: 0,
            flex: 1,
          }}
        >
          {item.content ||
            '"정말 유용한 후기네요! 혹시 더 자세한 내용 알려주실 수 있나요?"'}
        </H5>
        <Small
          onClick={handleDelete}
          sx={{
            fontSize: isMobile ? '14px' : '14px',
            color: theme.palette.primary.mainBlue,
            cursor: 'pointer',
            flexShrink: 0,
            fontWeight: '500',
          }}
        >
          삭제
        </Small>
      </Box>

      {/* Main Comment Row */}
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: isMobile ? '8px' : '12px',
          marginTop: '8px',
        }}
      >
        {/* Colored Tag */}
        {item.pillText && item.pillText.trim() !== '' && (
          <Box
            sx={{
              backgroundColor: getPillColor(),
              color: getPillTextColor(),
              padding: isMobile ? '2px 8px' : '3px 10px',
              borderRadius: '100px',
              fontSize: isMobile ? '12px' : '12px',
              fontWeight: '600',
              display: 'inline-block',
              flexShrink: 0,
            }}
          >
            {item.pillText}
          </Box>
        )}

        {/* Time */}
        <Small
          sx={{
            fontSize: isMobile ? '13px' : '13px',
            color: theme.palette.primary.greytxt,
            flexShrink: 0,
          }}
        >
          {formatTime(item.timeAgo)}
        </Small>

        {/* Description */}
        <Small
          sx={{
            fontSize: isMobile ? '13px' : '13px',
            color: theme.palette.primary.greytxt,
            flexShrink: 0,
          }}
        >
          {item.description || '내 댓글에 대한 답글'}
        </Small>
      </Box>
    </Box>
  );
};

export default MyPostItem;
